import type { RouteRecordRaw } from "vue-router"
import PageDashboardOptimisationContractuelle from "./pages/PageDashboardOptimisationContractuelle.vue"
import PageMesFactures from "./pages/PageMesFactures.vue"
import { beforeEnterDashboardOptimTurpe } from "./router/beforeEnterDashboardOptimTurpe"
import { beforeEnterMesFactures } from "./router/beforeEnterMesFactures"

// ====================================
// Module courtage
// ====================================
// Route comparateur (fiche bâtiment) : building.routes.ts
// Dashboard optimisation contractuelle (Optim Turpe) : plein écran sous layout header
// Espace « Mes factures » (DEV-714) : invoice-only, gate module `analyse-facture` + admin (R4)

export const routes = [
    {
        path: "/dashboard/optimisation-contractuelle",
        name: "PageDashboardOptimisationContractuelle",
        component: PageDashboardOptimisationContractuelle,
        meta: {
            requiresAuth: true,
            layout: "header",
        },
        beforeEnter: beforeEnterDashboardOptimTurpe,
    },
    {
        // Espace client « Mes factures » (DEV-714, couche 0 du flywheel courtage) :
        // invoice-only (frontière R1), réservé aux admins d'entreprise détentrices
        // du module `analyse-facture` (R4, via beforeEnterMesFactures).
        path: "/courtage/mes-factures",
        name: "PageMesFactures",
        component: PageMesFactures,
        beforeEnter: beforeEnterMesFactures,
        meta: {
            requiresAuth: true,
            layout: "header",
        },
    },
] as RouteRecordRaw[]
